// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__kvDOx"};